let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dbBUH")).then(() => parcelRequire('btTZq'));